import pino, { Logger as LoggerType } from 'pino';

class Logger {
  private logger!: LoggerType;

  constructor(opt: { enabled: boolean }) {
    // При переходе на Vitest - заменить на import.meta
    const level = process.env.VITE_FRONT_LOG_LEVEL || 'warn';

    this.logger = pino({
      enabled: opt.enabled,
      level,
    });
  }

  info(...args: Parameters<LoggerType['info']>) {
    this.logger.info(...args);
  }

  warn(...args: Parameters<LoggerType['warn']>) {
    this.logger.warn(...args);
  }

  error(...args: Parameters<LoggerType['error']>) {
    this.logger.error(...args);
  }
}

export const logger = new Logger({ enabled: typeof window !== 'undefined' });
